// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3hkxn","textarea":"styles_textarea__1uAdC"};